import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { inject, observer } from 'mobx-react'
import EnrollRequestForm from './EnrollRequestForm'
import Modal from 'react-overlays/Modal'
import { PAGEURL, CONSTS } from '../../../constants'
import styles from '../Marketplace.module.scss'
import classNames from 'classnames'

import { Button as ChaliceButton } from '../../theme/button/Button'

const modalStyle = function () {
  return {
    position: 'fixed',
    display: 'flex',
    flexAlign: 'center',

    justifyContent: 'center',
    width: '100%',
    height: '100%',
    zIndex: 2040,
    backgroundColor: 'transparent',
    padding: 0
  }
}

@inject('store')
@observer
class RequestConsultationButton extends React.Component {
  static propTypes = {
    product_id: PropTypes.string,
    company_id: PropTypes.number,
    enrollment_type: PropTypes.string,
    store: PropTypes.object.isRequired,
    allowAutoLaunch: PropTypes.bool,
    action_text: PropTypes.string,
    disabled: PropTypes.bool,
    disabled_for: PropTypes.string,
    product: PropTypes.object,
    showSubscriptionModel: PropTypes.bool,
    email: PropTypes.string,
    link: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.state = {
      showSubscriptionModel: (props.showSubscriptionModel || false)
    }
  }

  async componentDidMount () {
    if (this.props.allowAutoLaunch) {
      await this.props.store.getSubscriptionData(
        'loading', this.props.product_id, this.props.company_id)

      if (typeof window !== 'undefined') {
        if (window.location.pathname.match(/consultation/)) {
          this.showModal(null, 'loading')
        }
      }
    }
  }

  showModal = (event) => {
    const { product_slug } = this.props
    if (event) {
      event.preventDefault()
    }
    if (typeof window !== 'undefined') {
      window.history.pushState(null, null,
        `${PAGEURL.PRODUCT_DETAILS}${product_slug}/consultation/`)
    }
    this.setState({ showSubscriptionModel: true })
  }

  hide = (e) => {
    this.setState({
      showSubscriptionModel: false
    })
    if (typeof window !== 'undefined') {
      window.history.replaceState(null, null,
        `${PAGEURL.PRODUCT_DETAILS}${this.props.product_slug}/`)
    }
  }

  renderBackdrop (props) {
    return <div {...props} className={styles.consultation_backdrop} />
  }

  render () {
    const { store, product_id, product_slug, company_id, enrollment_type, action_text, product } = this.props
    const tt_info = CONSTS.PRODUCT_DETAILS_TOOLTIP[this.props.disabled_for]
    return (
      <>
        <div className={''}>
          {tt_info !== '' && (
            <div>
              <ReactTooltip place="top" type="dark" effect="float" />
              <ChaliceButton
                disabled={store.isReadonly() || this.props.disabled}
                onClick={(e) => this.showModal(e, 'loading')}
                className={classNames(styles.shrink_on_small, 'request-consultation')}>
                <span data-tip={tt_info}>
                  {action_text}
                </span>
              </ChaliceButton>
            </div>
          )}
          {tt_info === '' && (
            <ChaliceButton
              disabled={store.isReadonly() || this.props.disabled}
              onClick={(e) => this.showModal(e, 'loading')}
              className={classNames(styles.shrink_on_small, 'request-consultation')}>
              {action_text}
            </ChaliceButton>
          )}
        </div>
        {
          this.state.showSubscriptionModel === true &&
          <Modal
            onHide={ this.hide }
            style={ modalStyle() }
            show={ this.state.showSubscriptionModel }
            renderBackdrop={ this.renderBackdrop }
            onBackdropClick={ this.hide }>
            <EnrollRequestForm
              onClick={ this.hide }
              product_id={product_id}
              product_slug={product_slug}
              enrollment_type={enrollment_type}
              company_id={company_id}
              product={product}
              email={this.props.email}
              link={this.props.link}
            />
          </Modal>
        }
      </>
    )
  }
}

export default RequestConsultationButton
